export type LoyaltyLevel = {
  level: number;
  cp: number;
  prizeValues?: LoyaltyLevelPrizeValues;
  prizeLabel: LoyaltyLevelPrizeLabel;
};

export type LoyaltyLevelPrizeValues = {
  amount?: number;
  multiplier?: number;
  bonusAmount?: number;
};

export enum LoyaltyLevelPrizeLabel {
  CP = 'loyalty:boostBlock.levelPrizeLabels.CP',
  CP_CASHOUT = 'loyalty:boostBlock.levelPrizeLabels.CP_CASHOUT',
  CP_BONUS_CASH = 'loyalty:boostBlock.levelPrizeLabels.CP_BONUS_CASH',
  LOOTBOX = 'loyalty:boostBlock.levelPrizeLabels.LOOTBOX',
  CASHOUT = 'loyalty:boostBlock.levelPrizeLabels.CASHOUT',
  SPINS = 'loyalty:boostBlock.levelPrizeLabels.SPINS',
  BONUS_CASH = 'loyalty:boostBlock.levelPrizeLabels.BONUS_CASH',
  BONUS_CASH_CASHOUT = 'loyalty:boostBlock.levelPrizeLabels.BONUS_CASH_CASHOUT',
}

export const loyaltyLevels: LoyaltyLevel[] = [
  {
    level: 1,
    cp: 50,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 10 },
  },
  {
    level: 2,
    cp: 100,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 15 },
  },
  {
    level: 3,
    cp: 350,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 25 },
  },
  {
    level: 4,
    cp: 750,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 5,
    cp: 1000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 25 },
  },
  {
    level: 6,
    cp: 2000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 50 },
  },
  {
    level: 7,
    cp: 3500,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 10 },
  },
  {
    level: 8,
    cp: 5000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 75 },
  },
  {
    level: 9,
    cp: 7500,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 10,
    cp: 10000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 100 },
  },
  {
    level: 11,
    cp: 15000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 100 },
  },
  {
    level: 12,
    cp: 20000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 15 },
  },
  {
    level: 13,
    cp: 25000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 150 },
  },
  {
    level: 14,
    cp: 30000,
    prizeLabel: LoyaltyLevelPrizeLabel.CASHOUT,
    prizeValues: { multiplier: 2 },
  },
  {
    level: 15,
    cp: 35000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 15 },
  },
  {
    level: 16,
    cp: 40000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 200 },
  },
  {
    level: 17,
    cp: 45000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 25 },
  },
  {
    level: 18,
    cp: 50000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_BONUS_CASH,
    prizeValues: { amount: 350 },
  },
  {
    level: 19,
    cp: 55000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 20,
    cp: 60000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 200 },
  },
  {
    level: 21,
    cp: 70000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 500 },
  },
  {
    level: 22,
    cp: 80000,
    prizeLabel: LoyaltyLevelPrizeLabel.CASHOUT,
    prizeValues: { multiplier: 2 },
  },
  {
    level: 23,
    cp: 90000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 750 },
  },
  {
    level: 24,
    cp: 100000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 25,
    cp: 110000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 250 },
  },
  {
    level: 26,
    cp: 120000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 1000 },
  },
  {
    level: 27,
    cp: 130000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 35 },
  },
  {
    level: 28,
    cp: 140000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 1250 },
  },
  {
    level: 29,
    cp: 150000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 30,
    cp: 160000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 300 },
  },
  {
    level: 31,
    cp: 175000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 1500 },
  },
  {
    level: 32,
    cp: 190000,
    prizeLabel: LoyaltyLevelPrizeLabel.CASHOUT,
    prizeValues: { multiplier: 2 },
  },
  {
    level: 33,
    cp: 205000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 1750 },
  },
  {
    level: 34,
    cp: 220000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 35,
    cp: 235000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 350 },
  },
  {
    level: 36,
    cp: 250000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 2000 },
  },
  {
    level: 37,
    cp: 265000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 38,
    cp: 280000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_BONUS_CASH,
    prizeValues: { amount: 2500, bonusAmount: 50 },
  },
  {
    level: 39,
    cp: 295000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 40,
    cp: 310000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 400 },
  },
  {
    level: 41,
    cp: 330000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 3000 },
  },
  {
    level: 42,
    cp: 350000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 43,
    cp: 370000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 3500, multiplier: 2 },
  },
  {
    level: 44,
    cp: 390000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 45,
    cp: 410000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 450 },
  },
  {
    level: 46,
    cp: 430000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 4000 },
  },
  {
    level: 47,
    cp: 450000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 48,
    cp: 470000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_BONUS_CASH,
    prizeValues: { amount: 4500, bonusAmount: 75 },
  },
  {
    level: 49,
    cp: 490000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 50,
    cp: 510000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 500 },
  },
  {
    level: 51,
    cp: 540000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 5000 },
  },
  {
    level: 52,
    cp: 570000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 53,
    cp: 600000,
    prizeLabel: LoyaltyLevelPrizeLabel.CASHOUT,
    prizeValues: { amount: 5500, multiplier: 2 },
  },
  {
    level: 54,
    cp: 630000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 55,
    cp: 660000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 550 },
  },
  {
    level: 56,
    cp: 690000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 6000 },
  },
  {
    level: 57,
    cp: 720000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 100 },
  },
  {
    level: 58,
    cp: 750000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 6500, multiplier: 2 },
  },
  {
    level: 59,
    cp: 780000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 60,
    cp: 810000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 600 },
  },
  {
    level: 61,
    cp: 850000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 7000, multiplier: 2 },
  },
  {
    level: 62,
    cp: 890000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 63,
    cp: 930000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 7500 },
  },
  {
    level: 64,
    cp: 970000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 65,
    cp: 1010000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 650 },
  },
  {
    level: 66,
    cp: 1050000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 8000 },
  },
  {
    level: 67,
    cp: 1090000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH_CASHOUT,
    prizeValues: { amount: 125, multiplier: 2 },
  },
  {
    level: 68,
    cp: 1130000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 8500 },
  },
  {
    level: 69,
    cp: 1170000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 70,
    cp: 1210000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 700 },
  },
  {
    level: 71,
    cp: 1260000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 9000, multiplier: 2 },
  },
  {
    level: 72,
    cp: 1310000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 73,
    cp: 1360000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 9500 },
  },
  {
    level: 74,
    cp: 1410000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 75,
    cp: 1460000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 750 },
  },
  {
    level: 76,
    cp: 1510000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 10000 },
  },
  {
    level: 77,
    cp: 1560000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH_CASHOUT,
    prizeValues: { amount: 150, multiplier: 2 },
  },
  {
    level: 78,
    cp: 1610000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 12500 },
  },
  {
    level: 79,
    cp: 1660000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 80,
    cp: 1710000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 800 },
  },
  {
    level: 81,
    cp: 1760000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 15000 },
  },
  {
    level: 82,
    cp: 1810000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 200 },
  },
  {
    level: 83,
    cp: 1860000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 20000, multiplier: 2 },
  },
  {
    level: 84,
    cp: 1910000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 85,
    cp: 1960000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 850 },
  },
  {
    level: 86,
    cp: 2025000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 25000 },
  },
  {
    level: 87,
    cp: 2090000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 250 },
  },
  {
    level: 88,
    cp: 2155000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 89,
    cp: 2220000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 30000, multiplier: 2 },
  },
  {
    level: 90,
    cp: 2285000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 900 },
  },
  {
    level: 91,
    cp: 2360000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH_CASHOUT,
    prizeValues: { amount: 300, multiplier: 2 },
  },
  {
    level: 92,
    cp: 2435000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 93,
    cp: 2510000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 35000, multiplier: 2 },
  },
  {
    level: 94,
    cp: 2585000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 350 },
  },
  {
    level: 95,
    cp: 2660000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 950 },
  },
  {
    level: 96,
    cp: 2760000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 40000, multiplier: 2 },
  },
  {
    level: 97,
    cp: 2860000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH_CASHOUT,
    prizeValues: { amount: 400, multiplier: 2 },
  },
  {
    level: 98,
    cp: 2960000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 99,
    cp: 3060000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 45000, multiplier: 2 },
  },
  {
    level: 100,
    cp: 3160000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 1000 },
  },
];
